var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddWorkspaceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666667,
    y: 0.666667,
    width: 78.6667,
    height: 78.6667,
    rx: 15.3333,
    fill: "#F3F6FF",
    stroke: "#4991EA",
    strokeWidth: 1.33333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 45.3337L33.9596 39.3741C34.4123 38.9214 35.0264 38.667 35.6667 38.667C36.307 38.667 36.921 38.9214 37.3737 39.3741L42.6667 44.667M42.6667 44.667L44.6667 46.667M42.6667 44.667L45.2929 42.0407C45.7456 41.5881 46.3597 41.3337 47 41.3337C47.6403 41.3337 48.2544 41.5881 48.7071 42.0407L52 45.3337",
    stroke: "#4991EA",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 27.333C34.3604 27.333 31.5406 27.333 29.6704 28.9303C29.4048 29.1571 29.1575 29.4044 28.9307 29.67C27.3334 31.5402 27.3334 34.36 27.3334 39.9997C27.3334 45.6393 27.3334 48.4591 28.9307 50.3293C29.1575 50.5949 29.4048 50.8422 29.6704 51.069C31.5406 52.6663 34.3604 52.6663 40 52.6663C45.6396 52.6663 48.4595 52.6663 50.3296 51.069C50.5952 50.8422 50.8426 50.5949 51.0694 50.3293C52.6667 48.4591 52.6667 45.6393 52.6667 39.9997",
    stroke: "#4991EA",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6666 31.333C45.453 30.5239 47.5462 27.333 48.6666 27.333C49.787 27.333 51.8802 30.5239 52.6666 31.333M48.6666 27.9997V36.6663",
    stroke: "#4991EA",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddWorkspaceIcon);
export default __webpack_public_path__ + "static/media/Add_workspace _icon.9e315b7714cfec93e223d2f02d451dda.svg";
export { ForwardRef as ReactComponent };